<template>
  <el-dialog
    v-model="isVisible"
    title=""
    width="573px"
    :show-close="false"
    :close-on-click-modal="false"
    modal-class="item-not-allowed-dialog"
    destroy-on-close
    @close="$emit('close')"
  >
    <template #header>
      <div class="item-not-allowed-dialog__header">
        <div class="item-not-allowed-dialog__title-wrap">
          <img
            src="@/assets/MyPatient/input_order.svg"
            alt="Order"
            class="item-not-allowed-dialog__title-icon"
          />
          <span class="item-not-allowed-dialog__title">{{ content.title }}</span>
        </div>
        <button
          class="item-not-allowed-dialog__close-btn"
          type="button"
          @click="$emit('close')"
        >
          <img
            src="@/assets/MyPatient/close.svg"
            alt="Close"
            class="item-not-allowed-dialog__close-icon"
          />
        </button>
      </div>
    </template>
    <div class="item-not-allowed-dialog__content">
      {{ content.body }}
    <DbsSwitch 
      v-if="itemCategory === 'seasonalPromo'" 
      :dbs-toggle="dbsToggle" 
      :isPromoPanel="itemCategory === 'seasonalPromo'"
      @change="changeDbsVersion" 
      />
      <div class="item-not-allowed-dialog__footer">
        <LoginButton
          type="primary"
          class="item-not-allowed-dialog__action-btn"
          @click="itemCategory === 'seasonalPromo' ? $emit('done', dbsToggleOrigin == dbsToggle) : $emit('close')"
        >
          {{ itemCategory === "seasonalPromo" ? "Done" : "Close" }}
        </LoginButton>
      </div>
    <MenuSwitchDialog
      v-if="itemCategory === 'seasonalPromo'"
      :is-show-dbs-dialog="isShowMenuSwitchDialog"
      :discard-list="discardItemList"
      :different-price-list="differentPriceItemList"
      :same-price-list="samePriceItemList"
      @closeWithCancel="closeDbsDialog"
      @closeWithProceed="closeWithProceed"
    />
    </div>
  </el-dialog>
</template>

<script>
import MenuSwitchDialog from "./order-test-panel/menu-switch-dialog/index.vue";
import DbsSwitch from "./order-test-panel/DbsSwitch.vue";
import LoginButton from '@/views/login/components/LoginButton.vue';
import { mapState, mapGetters } from "vuex";
import _ from "lodash";
import { getAffectedItemLists } from "./order-test-panel/index.js";

export default {
  components: {
    MenuSwitchDialog,
    DbsSwitch,
    LoginButton,
  },

  props: {
    itemCategory: {
      type: String,
      default: ""
    },
    itemName: {
      type: String,
      default: ""
    },
    isShowDialog: {
      type: Boolean,
      default: false
    },
    dialogType: {
      type: String,
      default: "notAllowedForMenu"
    },
  },
  emits: ["close","done"],

  data() {
    return {
      isVisible: false,
      activeNames: ["orderTestPanel"],
      searchedItem: {},
      testOptions: [],
      dbsToggle: this.$store.state.orderTest.isDbsVersion,
      dbsToggleOrigin: this.$store.state.orderTest.isDbsVersion,
      isShowMenuSwitchDialog: false,
      discardItemList: [],
      differentPriceItemList: [],
      samePriceItemList: [],
      haveChosenDraftItems: false,
    };
  },

  computed: {
    ...mapState("orderTest", ["isDbsVersion"]),
    ...mapState("orderTest",[
      "switchToDbs",
      "switchToSerum",
      "isDbsVersion",
      "dbsMap",     
      "isAddOnOrder",
      "defaultSettings"
    ]),
    ...mapState("orderTest/promotions", ["selectedSeasonalPromoList"]),
    ...mapGetters("orderTest/tests", [
      "vaTestList", 
      "testList", 
      "selectedTestList",
      "serumCategorizedVwTests",
      "dbsCategorizedVwTests"
    ]),
    ...mapGetters("orderTest/panels", [
      "bundleList",
      "selectedCustomPanelList",
      "selectedDiscountPanelList",
      "selectedXChooseYPanelList"
    ]),
    ...mapGetters("orderTest/favorites", ["selectedShortcutList"]),

    changeVersionSupportObj() {
      return {
        selectedTestList: this.selectedTestList,
        selectedDiscountPanelList: this.selectedDiscountPanelList, 
        selectedCustomPanelList: this.selectedCustomPanelList, 
        selectedXChooseYPanelList: this.selectedXChooseYPanelList, 
        selectedSeasonalPromoList: this.selectedSeasonalPromoList, 
        selectedShortcutList: this.selectedShortcutList,
        dbsMap: this.dbsMap, 
        testList: this.testList, 
        bundleList: this.bundleList
      }
    },

    content() {
      let content = { title: "", body: "" };
      if (this.dialogType === "notAllowedForOfflineItem") {
        content.title = this.$t("OrderPage[\"Custom Panel is No Longer Available\"]");
        content.body = this.$t("OrderPage[\"Some panel items are unavailable. Please contact your sales representative for details.\"]");
      }
      if (this.dialogType === "notAllowedForPatientAge") {
        content = this.getNotAllowedForPatientAgeContent(this.itemCategory, this.itemName);
      }
      if (this.dialogType === "notAllowedForMenu") {
        content = this.getNotAllowedDialogContent(this.itemCategory === 'seasonalPromo' ?  this.dbsToggleOrigin : this.isDbsVersion, this.itemCategory, this.itemName);
      }
      if (this.dialogType === "notAllowedForCurrentPatient") {
        content = this.getNotAllowedForCurrentPatientContent(this.itemCategory, this.itemName);
      }
      return content;
    },
  },
  watch: {
    isShowDialog(newVal) {
      this.isVisible = newVal;
    },
    switchToDbs() {
      if (!this.dbsToggle) {
        this.changeDbsVersion(true);

      }
    },

    switchToSerum() {
      if (this.dbsToggle) {
        this.dbsToggle = false;
        this.changeDbsVersion(false);
       
      }
    },

     isDbsVersion(newVal) {
      this.dbsToggle = newVal;
    },  
  },
  mounted() {
    this.isVisible = this.isShowDialog;
  },
  methods: {
    getNotAllowedDialogContent(isDbs, panelCategory, panelName = "") {

      let isPromoPanelBody = this.$t("OrderPage[\"For an order to be eligible for this promotion, all tests must be ordered from the At Home Test Menu. Use this toggle or the one in the Order Test panel below to turn on the At Home Test Menu.\"]")

      let title = this.$t("OrderPage[\"At Home Test Menu -\"]") + (isDbs ? "ON" : "OFF");
      if (["va", "vw"].includes(panelCategory)) {
        let body = '';
        if (isDbs) {
          body = this.$t("OrderPage[\"This ${panelName} cannot be selected because it does not belong in the At Home Test Menu.\"]", { panelName: panelName });
        } else {
          body = this.$t("OrderPage[\"This ${panelName} cannot be selected because it belongs in the At Home Test Menu.\"]", { panelName: panelName });
        }
        return { title, body };
      }
      let panelCategoryText = panelCategory;
      if (panelCategory === "customPanel") {
        panelCategoryText = this.$t("OrderPage[\"Special Price Custom Panel\"]");
      }
      if (panelCategory === "shortcut") {
        panelCategoryText = this.$t("OrderPage[\"Shortcut Bundle\"]");
      }
      if (panelCategory === "seasonalPromo") {
        panelCategoryText = this.$t("OrderPage[\"Promo\"]");
      }
      let body = '';
      if (isDbs) {
        body = this.$t("OrderPage[\"This ${panelCategoryText} cannot be selected because it contains tests that are not in the At Home Test Menu.\"]", { panelCategoryText: panelCategoryText });
      } else {
        body = this.$t("OrderPage[\"This ${panelCategoryText} cannot be selected because it contains tests that are in the At Home Test Menu.\"]", { panelCategoryText: panelCategoryText });
      }
      return { title, body:this.itemCategory === 'seasonalPromo' ? isPromoPanelBody : body };
    },

    getNotAllowedForCurrentPatientContent(panelCategory, itemName) {
      let title = "Not Available for Current Patient";
      let panelCategoryText = itemName;
      if (panelCategory === "customPanel") {
        panelCategoryText = "Special Price Custom Panel";
      }
      if (panelCategory === "shortcut") {
        panelCategoryText = "Shortcut Bundle";
      }
      let body = `This ${panelCategoryText} contains Vibrant America tests that are not accessible for the currently selected patient.`;
      return { title, body };
    },

    getNotAllowedForPatientAgeContent(itemCategory, itemName) {
      let title = this.$t("OrderPage[\"Patient Does Not Meet Age Requirement\"]");
      let body = "";
      if (["va", "vw"].includes(itemCategory)) {
        body = this.$t("OrderPage[\"Hormone tests are only available for patients aged 15 and older.\"]");
      } else {
        body = this.$t("OrderPage[\"${itemName} cannot be added becaue it contains tests not meet age requirement.\"]", { itemName: itemName })
      }
      return { title, body };
    },

    changeDbsVersion(dbsToggle) {
      this.dbsToggle = dbsToggle;
      let { discardItemList, differentPriceItemList, samePriceItemList } = getAffectedItemLists(dbsToggle, this.changeVersionSupportObj);
      this.discardItemList = discardItemList;
      this.differentPriceItemList = differentPriceItemList;
      this.samePriceItemList = samePriceItemList;
      if (discardItemList.length > 0 || differentPriceItemList.length > 0) {
        dbsToggle ? this.isShowMenuSwitchDialog = true : this.isShowMenuSwitchDialog = true;
      }
      else {
        samePriceItemList.forEach((item) => {
          let removeTest = dbsToggle ? item.serumTest : item.dbsTest;
          let addTest = dbsToggle ? item.dbsTest : item.serumTest;
          let removePanel = dbsToggle ? item.serumPanel : item.dbsPanel;
          let addPanel = dbsToggle ? item.dbsPanel : item.serumPanel;
          switch (item.category) {
            case "vw":
              this.$store.dispatch("orderTest/removeSelectedTest", removeTest);
              this.$store.dispatch("orderTest/addSelectedTest", addTest);
              break;
            case "discountPanel":
              this.$store.dispatch("orderTest/removeSelectedDiscountPanel", removePanel);
              this.$store.dispatch("orderTest/addSelectedDiscountPanel", addPanel);
              break;
            case "xChooseY":
              this.$store.dispatch("orderTest/removeSelectedMultiChoosePanel", removePanel);
              this.$store.dispatch("orderTest/addSelectedMultiChoosePanel", addPanel);
              break;
            case "seasonalPromo":
              this.$store.dispatch("orderTest/removeSelectedSeasonalPromo", removePanel);
              this.$store.dispatch("orderTest/addSelectedDiscountPanel", addPanel);
              break;
            default:
              break;
          }
        });
        dbsToggle ? this.changeToDbsContent() : this.changeToSerumContent();
      }
    },

    closeDbsDialog() {
      this.isShowMenuSwitchDialog = false;
      this.dbsToggle = !this.dbsToggle;
    },

    changeToDbsContent() {
      this.$store.dispatch("orderTest/setIsDbsVersion", true);
      this.isShowMenuSwitchDialog = false;
    },

    changeToSerumContent() {
      this.$store.dispatch("orderTest/setIsDbsVersion", false);
      this.isShowMenuSwitchDialog = false;
    },

    closeWithProceed() {
      this.$store.dispatch("orderTest/setIsDbsVersion", this.dbsToggle);
      this.isShowMenuSwitchDialog = false;
    }
  }
}
</script>

<style>
.item-not-allowed-dialog .el-overlay-dialog {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.item-not-allowed-dialog .el-dialog {
  margin: 0 !important;
  border-radius: 10px;
  --el-dialog-padding-primary: 0px !important;
  height: auto !important;
  max-height: calc(100vh - 40px);
  overflow: hidden;
  display: block !important;
}

.item-not-allowed-dialog .el-dialog__header {
  padding: 0;
}

.item-not-allowed-dialog .el-dialog__body {
  padding: 0;
}
</style>

<style scoped>
.item-not-allowed-dialog__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background: #004879;
  color: #fff;
}

.item-not-allowed-dialog__title-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}

.item-not-allowed-dialog__title-icon {
  width: 24px;
  height: 24px;
  filter: brightness(0) invert(1);
}

.item-not-allowed-dialog__title {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.4;
}

.item-not-allowed-dialog__close-btn {
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
}

.item-not-allowed-dialog__close-icon {
  width: 100%;
  height: 100%;
}

.item-not-allowed-dialog__content {
  padding: 24px 36px;
  color: #161616;
  line-height: 20px;
  letter-spacing: 0.25px;
  word-break: normal;
}

.item-not-allowed-dialog__footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}

.item-not-allowed-dialog__action-btn {
  width: 144px;
}
</style>